'use strict';

// Mix Design workspace. The reusable EntityMetadataWorkspace provider renders the record's MixMetadata blob as the
// guided per-customer metadata form (read-only + inline Edit/Save) underneath the Overview field groups —
// MetadataBlob names the column + section heading. See source/providers/EntityMetadataWorkspace-Provider.js.
const libEntityMetadataWorkspaceProvider = require('../providers/EntityMetadataWorkspace-Provider.js');

module.exports = {
	Identifier: 'MixDesignWorkspace', Ordinal: 244,
	ProviderClass: libEntityMetadataWorkspaceProvider,
	MetadataBlob: { column: 'MixMetadata', label: 'Mix Metadata' },
	Entity: { Name: 'MixDesign', IDField: 'IDMixDesign', Collection: 'MixDesigns', GUIDField: 'GUIDMixDesign' },
	Header: { Eyebrow: 'Mix Design', Title: (r) => r.Name || `Mix Design ${r.IDMixDesign}`,
		Actions: [ { Label: 'Edit', Icon: 'fas fa-pen', Style: 'is-link', OnClick: 'goToEdit()' } ], ListRoute: '#/PSRS/MixDesign/List' },
	Tabs: [
		{ Key: 'overview', Label: 'Overview', Icon: 'fas fa-circle-info', Content: { kind: 'overview' } },
		{ Key: 'lots', Label: 'Lots', Icon: 'fas fa-boxes-stacked', Content: { kind: 'childlist', ref: 'Lot', parentField: 'IDMixDesign',
			columns: [ { Key: 'Name', Label: 'Name' } ], empty: 'No lots use this mix design.' } },
		{ Key: 'samples', Label: 'Samples', Icon: 'fas fa-vial', Content: { kind: 'childlist', ref: 'Sample', parentField: 'IDMixDesign',
			columns: [ { Key: 'LabControlNumber', Label: 'PSID' }, { Key: 'Name', Label: 'Description' } ], empty: 'No samples of this mix design.', cap: 200 } },
	],
	FieldGroups: [ { Name: 'Identity', Fields: [ { Key: 'Name', Label: 'Name', Wide: true }, { Key: 'MaterialCode', Label: 'Material Code', Mono: true }, { Key: 'Description', Label: 'Description', Wide: true } ] } ],
};
